import { React, useEffect, useState, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { GlobalLoading, showLoading } from "react-global-loading";
import { MyContextProvider } from "../../../App";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../Constant";
import DataTable from "react-data-table-component";
import { Link,useNavigate   } from "react-router-dom";
import messages from '../../../assets/Messages.json';

function UpdateDSLInfo() {
    const [dslInfoList,   setDslInfoList] = useState([]);
    const [surveyYear,   setSurveyYear] = useState('2024');
    const [searchText, setSearchText] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [districtList,setDistrictList]=useState([]);
    const [allDistrictsList,setAllDistrictsList]=useState([]);
    // const [yearName, setYearName] = useState('');
    const [year,setyear]=useState([]);  
    const [divisionList,setDivisionList]=useState([]);
    const [division,setdivision]=useState('');
    const [district,setdistrict]=useState('');
    const [divisionName,setdivisionName]=useState('');
    const [districtListByDivision,setDistrictListByDivision]=useState([]);
    const token=useContext(MyContextProvider).token;
    const decoded = getUserClaimsForUi();
    const userLevel = decoded?.id?.USER_TYPE;
    const [editForm, setEditForm] = useState({
      District_Code: "",
      District_Name:"",
      nameOfUnit: "",
      address: "",
      totalPerson: "",
      Place_Unit: "",
      Year:"",
      DSL_NO:""
    });
    const [validationErrors, setValidationErrors] = useState({
      nameOfUnit: "",
      address: "",
      totalPerson: "",
      Place_Unit: "",
    });
    const navigate = useNavigate ();
  
    // const districtOptions = [...new Set(dslInfoList.map((item) => item.District_Name))].filter(
    //   (name) => !!name
    // );

    const config = getAuthHeaders();
  
    useEffect(() => {
       fetchDivisionList();
       getSurveyYears();
       getDslInfoData();
       fetchDistrictList();
     }, []);
  

    const handleSearch = () => {
      //console.log("searchText", searchText);
     
      getDslInfoData();
    }
  
     const getSurveyYears=async()=>{
      // showLoading(true)
         try {
            const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
            const allYear = response.data;
             if (allYear.status) {
                setyear(allYear.data.surveyYearList.reverse())
                showLoading(false);
            }
      } catch (error) {
         console.error(error);
        //  showLoading(false);
      }
    
    }
    const fetchDivisionList = async () => {
      try {
         const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
         const allDivision = response.data;

        if (allDivision.status) {
          setDivisionList(allDivision.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

  
    const getDslInfoData= async()=>{
     let districtCode =  district !==''? parseInt(district, 10).toString(): "";
      showLoading(true);
      axios
        .post(`${API_URL}api/asi/alldslInfo`, {year: surveyYear,divisionCode: division,districtCode:districtCode,districtListByDivision:districtListByDivision.join(',')}, config)
        .then((res) => {
          let dslInfoList = res?.data;
         
          if (dslInfoList?.status && dslInfoList?.data?.length > 0) {
            setDslInfoList(dslInfoList.data);
          } else {
            setDslInfoList([]);
          }
          showLoading(false);
        })
        .catch((err) => {
          showLoading(false);
        });
  
    }
  // All district list
  const fetchDistrictList = async () => {
    try {
      const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
      const allDistrict = response.data;

      if (allDistrict.status) {
        setAllDistrictsList(allDistrict.data);
        setDistrictList(allDistrict.data); 
        showLoading(false);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }
  };
   
  const handleDivisionChange = async (event) => {
    const selectedDivision = event.target.value;
    // console.log("selectedDivision", selectedDivision);
    setdivision(selectedDivision);
    setDistrictListByDivision([]);
    if (userLevel !== "DIVISION LEVEL") {
      const _selectedText = event.target.options[event.target.selectedIndex].text;
      const _divisionName = _selectedText === "ALL" ? "" : _selectedText;
      setdivisionName(_divisionName);
    }
    // console.log("selectedDivision", allDistrictsList);
    
    if (selectedDivision) {
        // If division is selected, call the API immediately
        // showLoading(true);
        const post_data = {
            division_Id: selectedDivision
        };
        try {
            const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
            const allDistricts = response.data;
           
            // setDistrictListByDivision
            // console.log("allDistricts", allDistricts.data);
            if (allDistricts.status) {
                setDistrictList(allDistricts.data);
                const districtCodes = allDistricts.data.map(item => parseInt(item.DISTRICT_CODE,10));
                setDistrictListByDivision(districtCodes);
                console.log("districtListByDivision", districtListByDivision);
                // showLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    } else {
    
        setDistrictList(allDistrictsList);
    }
};

    const handleEditClick = (row) => {
      setEditForm({
        District_Code: row.District_Code || "",
        District_Name: allDistrictsList.find(item => item.DISTRICT_CODE == row.District_Code )?.DISTRICT_NAME || "",
        nameOfUnit: row.Name_Unit || "",
        address: row.Address_Unit || "",
        totalPerson: row.Total_Prson_Engaged || "",
        Place_Unit: row.Place_Unit || "",
        Year:row.Year || "",
        DSL_NO:row.DSL_NO || "",
      });
      setIsEditModalOpen(true);
    };

    const handleEditFieldChange = (e) => {
      const { name } = e.target;
      if (validationErrors[name]) {
        setValidationErrors((prev) => ({ ...prev, [name]: "" }));
      }
      if (name === "District_Code") {
        setEditForm((prev) => ({
          ...prev,
          District_Name: allDistrictsList.find((item) => parseInt(item.DISTRICT_CODE, 10) == e.target.value)?.DISTRICT_NAME || "",
          District_Code: e.target.value,
        }));
      } else {
        let { value } = e.target;
        if (name === "totalPerson") {
          value = value.replace(/\D/g, "").slice(0, 7);
        }
        setEditForm((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    };

    const handleEditModalClose = () => {
      setIsEditModalOpen(false);
      setValidationErrors({ nameOfUnit: "", address: "", totalPerson: "", Place_Unit: "" });
    };

    const validateForm = () => {
      const errors = {
        nameOfUnit: "",
        address: "",
        totalPerson: "",
        Place_Unit: "",
      };
      let isValid = true;
      const nameLength = editForm.nameOfUnit?.trim().length || 0;
      const addressLength = editForm.address?.trim().length || 0;
      const placeLength = editForm.Place_Unit?.trim().length || 0;
      const totalPersonStr = String(editForm.totalPerson ?? "").trim();

      if (!editForm.nameOfUnit?.trim()) {
        errors.nameOfUnit = "Name of Unit is required";
        isValid = false;
      } else if (nameLength > 150) {
        errors.nameOfUnit = "Name of Unit cannot be more than 150 characters";
        isValid = false;
      }
      if (!editForm.address?.trim()) {
        errors.address = "Address is required";
        isValid = false;
      } else if (addressLength > 250) {
        errors.address = "Address cannot be more than 250 characters";
        isValid = false;
      }
      if (editForm.totalPerson === "" || editForm.totalPerson === null || editForm.totalPerson === undefined) {
        errors.totalPerson = "Total Person is required";
        isValid = false;
      } else if (!/^\d+$/.test(totalPersonStr)) {
        errors.totalPerson = "Total Person must be a valid integer";
        isValid = false;
      } else if (Number(totalPersonStr) > 9999999) {
        errors.totalPerson = "Total Person cannot be greater than 9999999";
        isValid = false;
      }
      if (!editForm.Place_Unit?.trim()) {
        errors.Place_Unit = "Place of the Unit is required";
        isValid = false;
      } else if (placeLength > 50) {
        errors.Place_Unit = "Place of the Unit cannot be more than 50 characters";
        isValid = false;
      }

      setValidationErrors(errors);
      return isValid;
    };

    const handleEditModalSave = (e) => {

      if (window.confirm("Are you sure you want to update the DSL information?")) {
      e.preventDefault();
      if (!validateForm()) {
        // toast.error("Please fill all required fields correctly.");
        return;
      }
      console.log("Edit form submit data", editForm);
      // return false;

      // showLoading(true);
      axios
        .post(`${API_URL}api/asi/updateDslInfo`, editForm, config)
        .then((res) => {
          let response = res?.data;
          // console.log("response", response);
          if (response.status) {
            toast.success(response.message, messages.COLOR_RED);
            getDslInfoData();
            setIsEditModalOpen(false);
          }
        })
        .catch((err) => {
          // showLoading(false);
        });
      }else{
        e.preventDefault();
        
      }


    };
  
  
  

  
  
  
  
    const columns = [
      { name: "S.No.", selector: (row,index) => index + 1,maxWidth: "50px"},
      { name: "District Name", selector: (row) => row.District_Name, sortable: true,maxWidth: "200px"},
      { name: "Name of the Unit", selector: (row) => row.Name_Unit, sortable: true ,maxWidth: "700px"},
      { name: "Address", selector: (row) => row.Address_Unit, sortable: true ,maxWidth: "700Px"},
      { name: "Place of the Unit", selector: (row) => row.Place_Unit, sortable: true ,maxWidth: "700Px"},
      { name: "NIC4D", selector: (row) => row.NIC4D, sortable: true ,maxWidth: "130px"},
      { name: "Total Person", selector: (row) => row.Total_Prson_Engaged, sortable: true,maxWidth: "200px" },
      { name: "DSL No", selector: (row) => row.DSL_NO, sortable: true,maxWidth: "200px" },
      { name: "Year", selector: (row) => row.Year, sortable: true,maxWidth: "100px",minWidth: "100px" },
   
    
      {
        name: "Action",
        cell: (row) => (
          <>
          <Link to="#" onClick={(e) => { e.preventDefault(); handleEditClick(row); }}><i className="fa fa-edit fs-4" title="Edit"></i></Link>
         
        </>
        ),
        center:'true'
      },
    ];
  
    const customFilter = (rows, searchTerm) => {
      // console.log("searchTerm", searchTerm);
      // console.log("rows", rows);
      // showLoading(true)
      return rows.filter((row) => {
        const districtName = row.District_Name && row.District_Name.toLowerCase();
        const nameUnit = row.Name_Unit && row.Name_Unit.toLowerCase();
        const addressUnit = row.Address_Unit && row.Address_Unit.toLowerCase();
        const dslNo = row.DSL_NO;
     
        return (
          (districtName && districtName.includes(searchTerm.toLowerCase())) ||
          (nameUnit && nameUnit.includes(searchTerm.toLowerCase())) ||
          (addressUnit && addressUnit.includes(searchTerm.toLowerCase())) ||
          (dslNo && dslNo.toString().includes(searchTerm))
        
        );
      });
    };
  
    const customStyles = {
      rows: {
        style: {
          background: "#f2f2f2",
        },
      },
  
      table: {
        style: {
          border: "2px solid #ddd",
        },
      },
      headCells: {
        style: {
          fontSize: "15px",
          fontWeight: "bold",
        },
      },
    };
  
    return (
      <>
        <ToastContainer />
        <GlobalLoading />

        {isEditModalOpen && (
          <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Update DSL Info: <b>{editForm.DSL_NO}</b></h5>
                  <button type="button" className="btn-close" onClick={handleEditModalClose}></button>
                </div>
                <form onSubmit={handleEditModalSave}>
                  <div className="modal-body">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">District Name</label>
                        <select
                          className="form-select"
                          name="District_Code"
                          value={editForm.District_Code}
                          onChange={handleEditFieldChange}
                        >
                          <option value="">Select District</option>
                          { allDistrictsList.length > 0 && allDistrictsList.map((ele,i)=>{

                            return (   
                              ele.DISTRICT_CODE !== '00' &&
                              <option key={i} value={parseInt(ele.DISTRICT_CODE, 10)}>
                                {ele.DISTRICT_NAME}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Name of Unit <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${validationErrors.nameOfUnit ? "is-invalid" : ""}`}
                          name="nameOfUnit"
                          value={editForm.nameOfUnit}
                          onChange={handleEditFieldChange}
                          maxLength={150}
                          placeholder="Enter name of unit"
                        />
                        {validationErrors.nameOfUnit && (
                          <div className="invalid-feedback">{validationErrors.nameOfUnit}</div>
                        )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-12">
                        <label className="form-label">Address <span className="text-danger">*</span></label>
                        <textarea
                          className={`form-control ${validationErrors.address ? "is-invalid" : ""}`}
                          rows="3"
                          name="address"
                          value={editForm.address}
                          onChange={handleEditFieldChange}
                          maxLength={250}
                          placeholder="Enter address"
                        ></textarea>
                        {validationErrors.address && (
                          <div className="invalid-feedback">{validationErrors.address}</div>
                        )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Total Person <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          inputMode="numeric"
                          className={`form-control ${validationErrors.totalPerson ? "is-invalid" : ""}`}
                          name="totalPerson"
                          value={editForm.totalPerson}
                          onChange={handleEditFieldChange}
                          maxLength={7}
                          placeholder="Enter total person"
                        />
                        {validationErrors.totalPerson && (
                          <div className="invalid-feedback">{validationErrors.totalPerson}</div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Place of the Unit <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${validationErrors.Place_Unit ? "is-invalid" : ""}`}
                          name="Place_Unit"
                          value={editForm.Place_Unit}
                          onChange={handleEditFieldChange}
                          maxLength={50}
                          placeholder="Enter place of the unit"
                        />
                        {validationErrors.Place_Unit && (
                          <div className="invalid-feedback">{validationErrors.Place_Unit}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleEditModalClose}>
                      Close
                    </button>
                    <button type="submit" className="btn btn_orange">
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}




        <div className="container-fluid py-3">
          <div className="card mx-3 mb-3">
            <div className="card-body">
              <div className="row align-items-center">
                {/* <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search By District Name, Name of the Unit, Address and DSL No"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.trim())}
                  />
                </div> */}


           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Survey Year</label>
                <select value={surveyYear} onChange={ (event) => setSurveyYear(event.target.value)} name="surveyYear"  className="form-select">
                  {/* <option value="">Select Year</option> */}
                  {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => {
                        return (
                          (yearName == '2025'|| yearName == '2024' || yearName == '2023' || yearName == '2022')   &&
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                        )
                      })
                     }
              </select>
            </div>


            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Division</label>
                
                <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                  <option value="">ALL</option>
                  { divisionList.length > 0 && divisionList.map((ele,i)=>{
                    return (
                      ele.DIVISION_CODE !== '00' &&
                    <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                      {ele.DIVISION_NAME}
                    </option>
                    )
})}
                </select>
                
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>District</label>
              <select value={district} onChange={(event) => setdistrict(event.target.value)} name="district" className="form-select">
                <option value="">ALL</option>
                {districtList.map((ele, i) => (
                <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                  {ele.DISTRICT_NAME}
                </option>
              ))}
              </select>
            </div>

            <div className="col-xl-2 col-lg-12 mb-3">
              <label className="w-100 d-none d-sm-block">&nbsp;</label>
              <button type="submit" className="btn btn_orange"  onClick={handleSearch}>Search
                </button>
          </div>
 



            <div className="col-xl-4 col-lg-12 mb-3 text-end"  style={{ paddingTop: '28px' }}>
           {/* <div className="col-lg-4 col-md-6 col-sm-6 mb-4"> */}
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search By District Name, Name of the Unit, Address and DSL No"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.trim())}
                  />
                {/* </div> */}
            </div>

           


               </div>

              <div className="row">
                <div className="col-12 mb-4">
                  <DataTable
                    title=""
                    columns={columns}
                    data={
                      searchText.trim() !== ""
                        ? customFilter(dslInfoList, searchText)
                        : dslInfoList
                    }
                    persistTableHead
                    noDataComponent={<div className="py-3">No data found</div>}
                    pagination
                    customStyles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

export default UpdateDSLInfo